import { useCallback, useEffect, useState, useRef } from "react";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { getPercentageOrAmount } from "../../../utils/getPercentageOrAmount";
import { toast } from "react-toastify";

export const useRestaurantOrderDetails = ({
  restaurant,
  handleSetTip,
  tips,
  slectedTableHistroyForValidation,
  setIsToggleOn,
  isToggleOn,
  DeliverySelfCollectionStateInParent,
  isServiceChargeEnabled,
  handleServiceChargeToggle,
  // onUpdateServiceCharge,
}) => {
  const [restaurantId, setRestaurantId] = useState("");
  const [tableInfos, setTableInfos] = useState([]);
  const [selectedTable, setSelectedTable] = useState([]);
  const [userId, setUserId] = useState("");
  const [disabledAmount, setDisabledAmount] = useState(false);
  const [disabledPercentage, setDisabledPercentage] = useState(false);
  const [sessionTableData, setSessionTableData] = useState(
    sessionStorage.getItem("tableData")
  );
  const [specify, setSpecify] = useState(false);

  const initCalled = useRef(false);

  // Initialize accordion state based on whether table selection is needed
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(() => {
    const hasInStoreOrder = restaurant?.subOrders?.some(
      (subOrder) => subOrder.orderTypeName === "In-Store"
    );
    const needsTableSelection =
      hasInStoreOrder &&
      (!selectedTable?.tableId ||
        selectedTable?.restaurantId !== restaurant?.cartRestaurantId);
    return needsTableSelection;
  });

  // Check if there's a dine-in order that needs table selection
  const hasDineInOrderNeedingTable = restaurant?.subOrders?.some(
    (subOrder) =>
      subOrder.orderTypeName === "In-Store" &&
      (!selectedTable?.tableId ||
        selectedTable?.restaurantId !== restaurant?.cartRestaurantId)
  );

  // Auto-expand accordion if dine-in order needs table selection
  useEffect(() => {
    if (hasDineInOrderNeedingTable) {
      setIsAccordionExpanded(true);
    }
  }, [hasDineInOrderNeedingTable, selectedTable, restaurant?.cartRestaurantId]);

  console.log("wew", tips);
  /* Calculating Total of SubOrders */
  const totalBasePrice = () => {
    if (!restaurant) return 0;

    let total = 0;
    let subTotal = 0;

    restaurant.subOrders.forEach((subOrder) => {
      subOrder.itemDetails.forEach((item) => {
        const itemTotal =
          item.basePrice +
          item.vatInAmount +
          item.sdInAmount +
          item.vatOnSdInAmount;
        total += itemTotal * item.foodItemQuantity;
        subTotal += item.basePrice * item.foodItemQuantity;

        (item.addOns || []).forEach((addOn) => {
          const addonTotal =
            addOn.addOnBasePrice +
            addOn.addOnVatAmount +
            addOn.addOnSdAmount +
            addOn.addOnVatOnSdAmount;
          total += addonTotal * addOn.addOnQuantity;
          subTotal += addOn.addOnBasePrice * addOn.addOnQuantity;

          (addOn.options || []).forEach((option) => {
            const optionTotal =
              option.optionBasePrice +
              option.optionVatAmount +
              option.optionSdAmount +
              option.optionVatOnSdAmount;

            total += optionTotal * option.optionQuantity;
            subTotal += option.optionBasePrice * option.optionQuantity;

            (option.subOptions || []).forEach((subOption) => {
              const subOptionTotal =
                subOption.subOptionBasePrice +
                subOption.subOptionVatAmount +
                subOption.subOptionSdAmount +
                subOption.subOptionVatOnSdAmount;

              total += subOptionTotal * subOption.subOptionQuantity;
              subTotal +=
                subOption.subOptionBasePrice * subOption.subOptionQuantity;
            });
          });
        });
      });
      return subTotal;
    });

    const totalServiceCharge = getPercentageOrAmount(
      subTotal,
      restaurant.serviceCharge,
      "amount"
    );
    return (
      total +
      totalServiceCharge -
      restaurant.creditLimitPerOrder
    ).toFixed(2);
  };

  const totalBasePrice2 = () => {
    if (!restaurant) return 0;
    let total = 0;
    let subTotal = 0;

    restaurant.subOrders.forEach((subOrder) => {
      subOrder.itemDetails.forEach((item) => {
        const itemTotal =
          item.basePrice +
          item.vatInAmount +
          item.sdInAmount +
          item.vatOnSdInAmount;
        total += itemTotal * item.foodItemQuantity;
        subTotal += item.basePrice * item.foodItemQuantity;

        (item.addOns || []).forEach((addOn) => {
          const addonTotal =
            addOn.addOnBasePrice +
            addOn.addOnVatAmount +
            addOn.addOnSdAmount +
            addOn.addOnVatOnSdAmount;
          total += addonTotal * addOn.addOnQuantity;
          subTotal += addOn.addOnBasePrice * addOn.addOnQuantity;

          (addOn.options || []).forEach((option) => {
            const optionTotal =
              option.optionBasePrice +
              option.optionVatAmount +
              option.optionSdAmount +
              option.optionVatOnSdAmount;
            total += optionTotal * option.optionQuantity;
            subTotal += option.optionBasePrice * option.optionQuantity;

            (option.subOptions || []).forEach((subOption) => {
              const subOptionTotal =
                subOption.subOptionBasePrice +
                subOption.subOptionVatAmount +
                subOption.subOptionSdAmount +
                subOption.subOptionVatOnSdAmount;
              total += subOptionTotal * subOption.subOptionQuantity;
              subTotal +=
                subOption.subOptionBasePrice * subOption.subOptionQuantity;
            });
          });
        });
      });
    });

    const totalServiceCharge = getPercentageOrAmount(
      subTotal,
      restaurant.serviceCharge,
      "amount"
    );
    const serviceChargeVatAmount = getPercentageOrAmount(
      totalServiceCharge,
      20,
      "amount"
    );
    return total + totalServiceCharge + serviceChargeVatAmount;
  };

  // Tips Section

  // const assignTips = (amount) => {
  //     setTips(amount);
  // }

  const handleSpecifyInputValue = (event, restaurantId) => {
    const value = parseFloat(event.target.value) || 0; // Ensure the value is a number

    if (!value || parseFloat(value) === 0) {
      // If value is empty or zero, re-enable both inputs
      setDisabledPercentage(false);
      setDisabledAmount(false);
    } else {
      // If value is non-zero, disable the percentage input
      setDisabledPercentage(true);
    }

    handleSetTip(restaurantId, value, "amount"); // Update tip for the specified restaurant
  };

  const handleSpecifyPercentageInput = (event, restaurantId) => {
    const value = parseFloat(event.target.value) || 0;

    if (!value || parseFloat(value) === 0) {
      // If value is empty or zero, re-enable both inputs
      setDisabledAmount(false);
      setDisabledPercentage(false);
    } else {
      // If value is non-zero, disable the amount input
      setDisabledAmount(true);
    }

    handleSetTip(restaurantId, value, "percentage");
  };

  // useEffect(() => {
  //     alert(tips);
  // }, [tips]);

  useEffect(() => {
    const token = localStorage.getItem("gotasteClienttoken");
    if (token) {
      const user = jwtDecode(token);
      setUserId(user.UserId);
    }
  }, []);

  const getTableDetails = useCallback(async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/Cart/getTableDetailsByUserIdAndRestaurantId?userId=${userId}&restaurantId=${restaurantId}`
      );
      setSelectedTable(response.data);
      slectedTableHistroyForValidation(response.data);
    } catch (error) {
      console.log("Error fetching table info: ", error);
    }
  }, [userId, restaurantId]);

  // useEffect(() => {
  //   const init = async () => {
  //     const storedTableDetails = sessionStorage.getItem("tableData");
  //     const parsedTableDetails = JSON.parse(storedTableDetails);

  //     if (
  //       (!storedTableDetails ||
  //         parsedTableDetails.restaurantId !== restaurantId) &&
  //       restaurantId
  //     ) {
  //       await getTableDetails();
  //     } else {
  //       await handleSetTableDetails(parsedTableDetails);
  //     }

  //     setSelectedTable(parsedTableDetails);
  //     slectedTableHistroyForValidation(parsedTableDetails);
  //   };

  //   init();
  // }, []);

  // const initCalled = useRef(false);

  useEffect(() => {
    const hasRun = window.__tableCheckHasRun;
    if (hasRun) return;
    window.__tableCheckHasRun = true;

    if (initCalled.current) {
      console.log("initCalled.current is true, skipping init");
      return;
    }
    console.log("Running init");
    initCalled.current = true;

    const init = async () => {
      const storedTableDetails = sessionStorage.getItem("tableData");
      const parsedTableDetails = storedTableDetails
        ? JSON.parse(storedTableDetails)
        : null;

      if (
        (!storedTableDetails ||
          parsedTableDetails?.restaurantId !== restaurantId) &&
        restaurantId
      ) {
        console.log("Fetching table details");
        await getTableDetails();
      } else {
        console.log("Setting table details from sessionStorage");
        await handleSetTableDetails(parsedTableDetails);
        setSelectedTable(parsedTableDetails);
        // Fix typo: assuming it should be selectedTableHistoryForValidation
        slectedTableHistroyForValidation(parsedTableDetails);
      }
    };

    init();
  }, []); // Add restaurantId as a dependency if it changes

  // const initCalled = useRef(false);

  // useEffect(() => {
  //   if (initCalled.current) return;
  //   initCalled.current = true;

  //   const init = async () => {
  //     const storedTableDetails = sessionStorage.getItem("tableData");
  //     const parsedTableDetails = JSON.parse(storedTableDetails);

  //     if (
  //       (!storedTableDetails ||
  //         parsedTableDetails?.restaurantId !== restaurantId) &&
  //       restaurantId
  //     ) {
  //       await getTableDetails();
  //     } else {
  //       await handleSetTableDetails(parsedTableDetails);
  //        setSelectedTable(parsedTableDetails);
  //     slectedTableHistroyForValidation(parsedTableDetails);
  //     }
  //   };

  //   init();
  // }, []);

  const DeliverySelfCollectionState = (data) => {
    DeliverySelfCollectionStateInParent(data);
  };

  const handleSetTableDetails = async (table) => {
    const token = localStorage.getItem("gotasteClienttoken");
    const decoded = jwtDecode(token);

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SECRET}/api/Cart/UpdateCartTableDetails?customerId=${decoded.UserId}
        &TableId=${table.tableId}&TableName=${table.tableName}&RestaurantId=${table.restaurantId}`
      );

      if (response.data) {
        toast.success(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    restaurantId,
    setRestaurantId,
    selectedTable,
    setSelectedTable,
    disabledAmount,
    disabledPercentage,
    specify,
    setSpecify,
    isAccordionExpanded,
    setIsAccordionExpanded,
    totalBasePrice2,
    handleSpecifyInputValue,
    handleSpecifyPercentageInput,
    DeliverySelfCollectionState,
    handleSetTableDetails,
  };
};
